import { render, staticRenderFns } from "./ApiLookupSettingsModal.vue?vue&type=template&id=27a5b0c5&scoped=true&"
import script from "./ApiLookupSettingsModal.vue?vue&type=script&lang=js&"
export * from "./ApiLookupSettingsModal.vue?vue&type=script&lang=js&"
import style0 from "./ApiLookupSettingsModal.vue?vue&type=style&index=0&id=27a5b0c5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a5b0c5",
  null
  
)

export default component.exports